import { createFileRoute } from "@tanstack/react-router";
import AdminMentors from "@/pages/AdminMentors";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/mentors/")({
  component: () => (
    <RoleGate allow={['staff']} area="Mentors"><AdminMentors /></RoleGate>
  ),
});
